import { makeStyles } from '@fluentui/react-components';

export const useRatingStarsStyles = makeStyles({
    container: {
        display: 'flex',
        gap: '2px',
    },
});
